import PropTypes from 'prop-types';

import Icon from '@/common-utils/components/renders/icon/Icon';
import ICONS from '@/common-utils/enums/icons';
import { findCbLogoFromType } from '../../../enums/CbLogoFromPan';
import TooltipHelper from '@/common-utils/components/renders/tooltip/TooltipHelper';
import Entity from '@/common-utils/components/renders/entity/Entity';
import { nsTerminal } from '@/app/i18n/namespaces';

function RenderCbLogo({ cardType }) {

    const cbLogo = cardType ? findCbLogoFromType(cardType) : null;
    return (
        cbLogo && cbLogo.logo ?
            <div title={cbLogo.name} className='flex flex-col items-center'>
                <div>
                    <img className='cbLogo'
                        alt={cbLogo.name}
                        src={cbLogo.logo}
                    />
                </div>
                <div className={'cbName'}>
                    {cbLogo && cbLogo.name ?
                        <div className='pan'>{cbLogo.name}</div>
                        : false}
                </div>
            </div>
            :
            // No cb found
            <div className='flex flex-col items-center'>
                <TooltipHelper
                    trigger={
                        <Icon
                            icon={ICONS.CREDIT_CARD}
                        />
                    }
                    content={
                        <div>
                            <Entity entity='cb_logo.unknown_card' namespace={nsTerminal} />
                        </div>
                    }
                />
            </div>
    );
}

RenderCbLogo.propTypes = {
    cardType: PropTypes.string
};

export default RenderCbLogo;